import {Box, Button, ClickAwayListener, Grow, IconButton, makeStyles, ThemeProvider, Typography} from "@material-ui/core"
import * as React from "react"
import * as ReactDOM from "react-dom"
import { Theme } from "../../entryes/panel/MUI"
import { tl } from "../../utils"
import ChevronDown from "../Icons/chevronDown"
import GiftIcon from "../Icons/gift"
import LessonIcon from "../Icons/lesson"
import TelegramIcon from "../Icons/socials/telegram"
import VKIcon from "../Icons/socials/VK"
import YoutubeIcon from "../Icons/socials/youtube"
import { StepsIndicator } from "./stepIndicator"
import { Accordion } from "./accordion"
import api from "../../api"
import { action, computed, observable } from "mobx"
import { MobXProviderContext, Observer, observer, Provider } from "mobx-react"
import {Centrifuge, PublicationContext, Subscription} from 'centrifuge'


interface OnboardingTasks {
  check_howework: boolean
  create_course: boolean
  create_lesson: boolean
  gift: boolean
  invite_student: boolean
  register: boolean
  student_course_done: boolean
}

type TTaskType = keyof OnboardingTasks

class OnboardingStore {
  static LS_KEY = `onboard_opend_${window._user_id}`;
  static CHANNEL_KEY = `at_notification:at_notify_${window._user_id}`
  sub: Subscription;
  wsConnection: Centrifuge;
  @observable
  tasks?: OnboardingTasks;
  @observable
  loading: boolean;
  @observable
  isOpen: boolean = false;
  @observable
  openedTask?: TTaskType

  @observable
  giftLoading: boolean;

  @observable
  isOpenForTheFirstTime: string | null;

  @observable
  isPrizeTaken: boolean = false;

  constructor(ws: any) {
    this.wsConnection = ws;
    this.init();
  }

  async init() {
    const isOpenForTheFirstTime = localStorage.getItem(OnboardingStore.LS_KEY);
    this.isOpenForTheFirstTime = isOpenForTheFirstTime;
    // if (!this.isOpenForTheFirstTime) {
    //   this.isOpen = true;
    // }
    await this.getFinishedTasks();
    if (this.finishedTasks.length !== Object.keys(this.tasks).length) {
      this.subscribe();
    }
  }

  @action
  async getFinishedTasks() {
    this.loading = true;
    try {
      const res = await api.user.onboardingTasks();
      this.tasks = res.data;
      this.loading = false;
      if (this.tasks && this.tasks['gift']) {
        this.isPrizeTaken = true;
      }
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

  }

  @action
  async reclaimGift() {
    this.giftLoading = true;
    try {
      await api.user.onboardingFinish();
      this.giftLoading = false;
      this.isPrizeTaken = true;
    } catch (error) {
      console.log(error);
      this.giftLoading = false;
    }
  }

  @computed
  get finishedTasks() {
    if (!this.tasks) return [];
    return Object.keys(this.tasks).filter((key: TTaskType) => this.tasks[key] === true)
  }


  subscribe() {
    this.sub = this.wsConnection.getSubscription(OnboardingStore.CHANNEL_KEY)
    if (!this.sub) {
      this.sub = this.wsConnection.newSubscription(OnboardingStore.CHANNEL_KEY);
      this.sub.subscribe();
    }
    this.sub.on("publication", (ctx: PublicationContext) => {
      console.log(ctx.data);
    })
  }

  unsubscribe() {

    this.sub.unsubscribe();
  }

  setOpenedTask(task?: TTaskType) {
    this.openedTask = task;
  }

  setIsOpen(open: boolean) {
    if (this.isOpenForTheFirstTime === null) {
      localStorage.setItem(OnboardingStore.LS_KEY, 'no');
      this.isOpenForTheFirstTime = 'no';
    }
    this.isOpen = open;
  }
}

export const OnboardWidget: React.FC = observer(() => {
  const {store} = React.useContext<{
    store: OnboardingStore
  }>(MobXProviderContext)
  const classes = useStyles();
  return (
    <React.Fragment>
      <Grow 
        in={store.isOpen}
        style={{ transformOrigin: 'bottom left', zIndex: 1350 }}  
        unmountOnExit 
        mountOnEnter
      >
        <ClickAwayListener onClickAway={() => store.setIsOpen(false)}>
        {store.loading || store.tasks === undefined
          ? <div />
          : <div className={classes.root}>
              <Box display="flex" flexDirection="row" flex={1} alignItems="flex-start" justifyContent="space-between" mb={2}>
                <Typography className={classes.headingText}>
                  {tl('Выполни задания и получи 7 дней доступа к платформе бесплатно')}
                </Typography>
                <IconButton className={classes.closeBtn} onClick={() => store.setIsOpen(false)}>
                  <ChevronDown fontSize="inherit" color="primary" />
                </IconButton>
              </Box>
              <Typography className={classes.descriptionText}>
                {tl('А чтобы получить скидку до 30% в первые 7 дней после регистрации обращайся к менеджеру или в поддержку')}
              </Typography>
              <Box display="flex" flexDirection="row" flex={1} alignItems="center" mb={2}>
                <Observer>
                  {() => (
                      <StepsIndicator 
                        amount={Object.keys(store.tasks).filter(task => task !== 'gift').length} 
                        successBlocks={store.finishedTasks.map((_, i) => i)} 
                        errorBlocks={[]} 
                    />
                  )}
                </Observer>
                <IconButton className={classes.giftBtn}>
                  <GiftIcon fontSize="inherit" />
                </IconButton>
              </Box>
              <div className={classes.tipsContainer}>
                {!store.isPrizeTaken ? 
                  store.finishedTasks.length < 5 ?
                    <React.Fragment>
                      <Accordion 
                        open={'register' === store.openedTask}
                        title={tl('Зарегистрируй аккаунт')}
                        isDone={store.tasks['register']}
                        onOpenClose={() => store.openedTask === 'register' ? store.setOpenedTask() : store.setOpenedTask('register')}
                      >
                        <Typography className={classes.text}>
                          {tl('Зарегистрировать аккаунт')}
                        </Typography>
                      </Accordion>
                      <Accordion 
                        open={'create_course' === store.openedTask}
                        title={tl('Создай курс')}
                        isDone={store.tasks['create_course']}
                        onOpenClose={() => store.openedTask === 'create_course' ? store.setOpenedTask() : store.setOpenedTask('create_course')}
                      >
                        <Typography className={classes.text}>
                          {tl('Этот урок поможет тебе создать свой первый курс')}
                        </Typography>
                        <Box mt={1.5}>
                          <Button color="primary" target="_blank" variant="contained" href="https://antitreningi.ru/student/lessons/lesson?course_id=28315&lesson_id=443459">{tl('Перейти к уроку')}</Button>
                        </Box>
                      </Accordion>
                      <Accordion 
                        open={'create_lesson' === store.openedTask}
                        title={tl('Добавь урок')}
                        isDone={store.tasks['create_lesson']}
                        onOpenClose={() => store.openedTask === 'create_lesson' ? store.setOpenedTask() : store.setOpenedTask('create_lesson')}
                      >
                        <Typography className={classes.text}>
                          {tl('Теперь нужно создать свой урок')}
                        </Typography>
                        <Box mt={1.5}>
                          <Button color="primary" variant="contained" target="_blank" href="https://antitreningi.ru/student/lessons/lesson?course_id=28315&lesson_id=443669">{tl('Перейти к уроку')}</Button>
                        </Box>
                      </Accordion>
                      <Accordion 
                        open={'invite_student' === store.openedTask}
                        title={tl('Добавь ученика')}
                        isDone={store.tasks['invite_student']}
                        onOpenClose={() => store.openedTask === 'invite_student' ? store.setOpenedTask() : store.setOpenedTask('invite_student')}
                      >
                        <Typography className={classes.text}>
                          {tl('Добавь ученика по этой инструкции')}
                        </Typography>
                        <Box mt={1.5}>
                          <Button color="primary" variant="contained" target="_blank" href="https://antitreningi.ru/student/lessons/lesson?course_id=28315&lesson_id=443950">{tl('Перейти к уроку')}</Button>
                        </Box>
                      </Accordion>
                      <Accordion 
                        open={'check_howework' === store.openedTask}
                        title={tl('Проверь домашнее задание')}
                        isDone={store.tasks['check_howework']}
                        onOpenClose={() => store.openedTask === 'check_howework' ? store.setOpenedTask() : store.setOpenedTask('check_howework')}
                      >
                        <Typography className={classes.text}>
                          {tl('Узнайте, как проверять домашние задания')}
                        </Typography>
                        <Box mt={1.5}>
                          <Button color="primary" variant="contained" target="_blank" href="https://antitreningi.ru/student/lessons/lesson?course_id=28315&lesson_id=444181">{tl('Перейти к уроку')}</Button>
                        </Box>
                      </Accordion>
                      <Accordion 
                        open={'gift' === store.openedTask}
                        title={tl('Получи 7 дней бесплатно')}
                        isDone={store.tasks['gift']}
                        onOpenClose={() => store.openedTask === 'gift' ? store.setOpenedTask() : store.setOpenedTask('gift')}
                      >
                        <Typography className={classes.text}>
                          {tl('Выполните предыдущие этапы, чтобы получить еще 7 дней бесплатного доступа к платформе.')}
                        </Typography>
                      </Accordion>
                    </React.Fragment>
                    : <React.Fragment>
                        <Accordion 
                          open={'gift' === store.openedTask}
                          title={tl('Забрать подарок')}
                          isDone={store.tasks['gift']}
                          onOpenClose={() => store.openedTask === 'gift' ? store.setOpenedTask() : store.setOpenedTask('gift')}
                        >
                          <Typography className={classes.text}>
                            {tl('Ты прошел все этапы обучения и теперь точно знаешь что делать! ')}
                          </Typography>
                          <br />
                          <Typography className={classes.text}>
                            {tl("Мы дарим тебе еще 7 дней бесплатного доступа, чтобы ты успел воспользоваться полученными знаниями на практике :)")}
                          </Typography>
                        </Accordion>
                        <Button 
                          variant="contained" 
                          color="primary" 
                          fullWidth 
                          onClick={() => store.reclaimGift()}
                          disabled={store.giftLoading}
                        >{tl('Забрать подарок')}</Button>
                      </React.Fragment> 
                    : <React.Fragment>
                        <div className={classes.tip}>
                          <Typography className={classes.endText}>{tl('Бонусная неделя начислена')}</Typography>
                          <Typography className={classes.text}>
                            {tl("Скоро она отобразится на твоем акаунте, а пока можешь подписаться на наши соц. сети.")}
                          </Typography>
                          <br />
                          <Typography className={classes.text}>
                            {tl("Там мы рассказываем обо всех обновлениях сервиса и анонсирует полезные вебинары по онлайн обучению!")}
                          </Typography>
                        </div>
                        <div className={classes.socialRoot}>
                          <Button href="https://t.me/at_upd" target="_blank" variant="contained" color="primary" className={classes.socialLink}>
                            <TelegramIcon />
                          </Button>
                          <Button href="https://www.youtube.com/channel/UCxGKCq7uYJx_XghdBh7kqTQ"  target="_blank" variant="contained" color="primary" className={classes.socialLink}>
                            <YoutubeIcon />
                          </Button>
                          <Button href="https://vk.com/antitreningi" variant="contained"  target="_blank" color="primary" className={classes.socialLink}>
                            <VKIcon />
                          </Button>
                        </div>
                      </React.Fragment>
                    }
              </div>
            </div>
        }
        </ClickAwayListener>
      </Grow>
      <div className={classes.iconBox} onClick={() => store.setIsOpen(!store.isOpen)}>
        {!store.isOpen && 
          <div className={classes.iconBoxBadge}>
            <span>!</span>
          </div>}
        <LessonIcon fontSize="inherit" />
      </div>
    </React.Fragment>
  )
})

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#FFF',
    boxShadow: '0px 4px 40px rgba(0, 0, 0, 0.1)',
    borderRadius: theme.shape.borderRadius,
    maxWidth: 366,
    maxHeight: 'calc(100vh - 103px)',
    overflowY: 'auto',
    padding: theme.spacing(3),
    position: 'relative',
    left: 60,
    height: 502,
    scrollbarWidth: 'none',
    overscrollBehavior: 'contain',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      left: 0,
      height: '100vh',
      bottom: -50,
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  headingText: {
    fontSize: 16,
    lienHeight: '19px',
    fontWeight: 500,
  },
  descriptionText: {
    fontSize: 14,
    lineHeight: '17px',
    fontWeight: 500,
  },
  iconBox: {
    width: 60,
    height: 60,
    background: '#FFF',
    color: theme.palette.primary.main,
    display: 'flex',
    fontSize: 30,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    postition: 'relative',
    filter: 'drop-shadow(0px 2px 20px rgba(0, 0, 0, 0.1))',
  },
  iconBoxBadge: {
    position: 'absolute',
    right: -5,
    top: -5,
    fontFamily: 'SF UI Text',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '18px',
    width: 20,
    height: 20,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  giftBtn: {
    border: 'none',
    outline: 'none',
    backgroundColor: '#FF8227',
    borderRadius: '50%',
    width: 40,
    height: 40,
    color: '#FFF',
    marginLeft: theme.spacing(2),
    fontSize: 20,
    '&:hover' : {
      backgroundColor: '#FF8227',
    }
    // boxShadow: '0px 4px 40px rgba(0, 0, 0, 0.1)',
  },
  tipsContainer: {
    backgroundColor: '#FFF',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      boxShadow: 'none',
    },
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
  },
  tip: {
    display: 'flex',
    flex: 1,
    flexFlow: 'column nowrap',
    backgroundColor: '#F0F7FD',
    borderRadius: 4,
    margin: 0,
    marginBottom: 8,
    padding: theme.spacing(2),
  },
  closeBtn: {
    padding: 0,
    margin: 2,
    fontSize: 24,
  },
  socialRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    alignSelf: 'center',
    marginTop: 20,
  },
  socialLink: {
    width: 40,
    height: 40,
    borderRadius: '50%',
  },
  endText: {
    fontSize: 15,
    lineHeight: '18px',
    fontWeight: 500,
    marginBottom: 14,
  },
  text: {
    fontSize: 13,
    lineHeight: '15.5px',
  }
}))


window.react_render_onboard_widget = function(props: {ws: any}) {
  const onboardingStore = new OnboardingStore(props.ws);
  ReactDOM.render(
    <Provider store={onboardingStore}>
      <ThemeProvider theme={Theme}>
        <OnboardWidget />
      </ThemeProvider>
    </Provider>, 
  document.getElementById('onboardWidget'))
}